import type { TFunction } from 'i18next';
import type { GridColDef } from '@mui/x-data-grid-pro';

import type { RefuelDataGridRow } from '../../../types/RefuelDataGridRow.types';

type FuelValueField = 'startFuelLevel' | 'amountRefuels' | 'stopFuelLevel';
type TextField = 'refuelDate' | 'refuelPlace';

function formatFuelValue(value: number) {
  return Number.isInteger(value) ? value.toString() : value.toFixed(1);
}

function createTextColumn(field: TextField, headerName: string): GridColDef<RefuelDataGridRow> {
  return {
    field,
    headerName,
    flex: 1,
    type: 'string',
    sortable: true,
  };
}

function createFuelValueColumn(field: FuelValueField, headerName: string): GridColDef<RefuelDataGridRow> {
  return {
    field,
    headerName,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    type: 'number',
    valueFormatter: formatFuelValue,
    sortable: true,
  };
}

export function createRefuelColumns(t: TFunction) {
  return [
    createTextColumn('refuelDate', t('refuels.table.header.refuelDate')),
    createTextColumn('refuelPlace', t('refuels.table.header.refuelPlace')),
    createFuelValueColumn('startFuelLevel', t('refuels.table.header.startFuelLevel')),
    createFuelValueColumn('amountRefuels', t('refuels.table.header.amountRefuels')),
    createFuelValueColumn('stopFuelLevel', t('refuels.table.header.stopFuelLevel')),
  ] satisfies GridColDef<RefuelDataGridRow>[];
}
